import React from 'react';
import { ConcernRequirement } from 'generated/api';

interface ConcernRequirementBadgeProps {
  requirement: ConcernRequirement;
  style?: React.CSSProperties;
}

const ConcernRequirementBadge = ({ requirement, style }: ConcernRequirementBadgeProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', ...style }}>
      <div style={{ fontWeight: 500, fontSize: '0.85rem', color: '#2b3857' }}>
        {requirement.label}
      </div>
      {requirement.description && (
        <div style={{ fontSize: '0.75rem', color: '#888', fontWeight: 400, lineHeight: 1.2 }}>
          {requirement.description}
        </div>
      )}
    </div>
  );
};

export default ConcernRequirementBadge;
